import React, { useState, useEffect } from "react";
import { X, Star, BadgeCheck } from "lucide-react";

const GOOGLE_REVIEW_URL = "https://g.page/r/CWM_ouLn_9JqEBM/review";

const GoogleReviewBadge = () => {
  const [dismissed, setDismissed] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("google-rating-dismissed")) {
      setDismissed(true);
      return;
    }
    // Fade in after 2s so it feels non-intrusive
    const t = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(t);
  }, []);

  const close = (e) => {
    e.preventDefault();
    e.stopPropagation();
    sessionStorage.setItem("google-rating-dismissed", "1");
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <a
      href={GOOGLE_REVIEW_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-rating-badge"
      aria-label="Avis Google 5 étoiles — laissez votre avis"
      className={`hidden md:flex fixed bottom-24 left-6 z-30 bg-white rounded-full pl-2 pr-3 py-1.5 shadow-2xl items-center gap-2 group hover:scale-105 transition-all duration-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2 pointer-events-none"}`}
    >
      <button
        onClick={close}
        aria-label="Fermer"
        className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-black/70 hover:bg-black text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <X size={10} />
      </button>

      {/* Google G logo */}
      <div className="w-6 h-6 flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className="w-5 h-5">
          <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
          <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
          <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
          <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571.001-.001.002-.001.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
        </svg>
      </div>

      <div className="flex flex-col leading-tight pr-1">
        <div className="flex items-center gap-1">
          <span className="text-[11px] font-semibold text-[#1F1F1F]">Avis Google</span>
          <BadgeCheck size={11} className="text-[#1A73E8] fill-[#1A73E8] stroke-white" />
        </div>
        <div className="flex items-center gap-1">
          <div className="flex items-center">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} size={10} className="fill-[#FBBC04] text-[#FBBC04]" />
            ))}
          </div>
          <span className="text-[10px] font-medium text-[#5F6368]">Laisser un avis</span>
        </div>
      </div>
    </a>
  );
};

export default GoogleReviewBadge;
